// Workaround for the fact that React does not allow us to add these functions with a hook, we instantiate these in the App.js file then call them in the interceptors
let logoutFn;

export const setLogout = (fn) => {
  logoutFn = fn;
};

export const doLogout = () => {
  if (logoutFn) {
    logoutFn();
  }
};
